import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModularQuestion } from 'src/app/models/modularQuestion.model';
import { EQuestionType } from 'src/app/models/questionType.model';
import { AutocompleteQuestionDisplayComponent } from '../../autocomplete-question-display/autocomplete-question-display.component';
import { DateQuestionDisplayComponent } from '../../date-question-display/date-question-display.component';
import { NumberQuestionDisplayComponent } from '../../number-question-display/number-question-display.component';
import { FillQuestionDisplayComponent } from '../../fill-question-display/fill-question-display.component';
import { PhoneNumberQuestionDisplayComponent } from '../../phone-number-question-display/phone-number-question-display.component';
import { Question } from 'src/app/models/question.model';
import { MarkQuestionDisplayComponent } from '../../mark-question-display/mark-question-display.component';
import { AnswersStore } from 'src/app/store/answers-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DisplayApiFieldNameComponent } from '../../../../question/components/display-api-field-name/display-api-field-name.component';

@Component({
    selector: 'que-question-group-item-dispaly',
    imports: [CommonModule,
        AutocompleteQuestionDisplayComponent,
        DateQuestionDisplayComponent,
        NumberQuestionDisplayComponent,
        FillQuestionDisplayComponent,
        PhoneNumberQuestionDisplayComponent,
        MarkQuestionDisplayComponent,
        TranslateDirective, TranslatePipe,
        DisplayApiFieldNameComponent
    ],
    templateUrl: './question-group-item-dispaly.component.html',
    styleUrls: ['./question-group-item-dispaly.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionGroupItemDispalyComponent {
  @Input() modularQuestion?: ModularQuestion;
  @Input() modularOrder?: number;
  @Input() questionId?: number;
  @Input() required?: boolean;
  @Input() isPreview = false;
  #answerStore = inject(AnswersStore);
  eQuestionType = EQuestionType;
  question?: Question;
  valueMark = false;
  ngOnInit() {
    if (this.modularQuestion) {
      this.question = {
        id: this.questionId,
        type:this.modularQuestion.type,
        title: this.modularQuestion.title,
        optionsList: this.modularQuestion.optionsList,
        status: this.modularQuestion.status,
        requierd:this.required
      } as Question;
    }
  }

}
